export enum RecoilLoadableStatesEnum {
	LOADING = 'loading',
	HAS_ERROR = 'hasError',
	HAS_VALUE = 'hasValue',
}
